<template>
  <div>
    <el-button @click="dialogObject=true">Прикрепить файл</el-button>
    <el-dialog title="Прикрепить файл"         :disabled="disabled"
               :visible.sync="dialogObject">
      <el-upload
        :disabled="disabled"
        v-if="uploadValue === null"
        list-type="picture"
        :http-request="onUpload"
        class="upload-demo"
        accept="image/*"
        action="/"
        :show-file-list="false"
        drag
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Перетащите файл сюда или <em>нажмите, чтобы загрузить</em></div>
      </el-upload>
      <el-progress v-else :percentage="uploadValue"></el-progress>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogObject = false">Ok</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {v4 as uuidv4} from 'uuid';

export default {
  name: 'UploadFile',
  props: {
    fileListProps : Array,
    disabled: Boolean
  },
  data() {
    return {
      search: '',
      fileList: [],
      dialogObject: false,
      unit: '',
      uploadValue: null,
      jobs: [],
      step: 0,
      form: {
        value: '',
        unit: '',
        job: '',
      },
    };
  },
  computed: {
    filteredList() {
      return this.jobs.filter(job => {
        return job.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  watch: {
    fileListProps() {
      this.fileList = this.fileListProps;
    },
  },
  methods: {
    onUpload(e) {
      const imageData = e.file;
      const storageRef = firebase.storage(
      ).ref(`reports/${uuidv4()}`).put(imageData);
      storageRef.on(`state_changed`, snapshot => {
          this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        }, error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.$emit('add-file', url);
            this.dialogObject = false;
            this.uploadValue = null;
          });
        },
      );
    },
    save() {
      this.$emit('add-job', {
        ...this.form,
      });
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form.value = '';
      this.form.unit = '';
      this.form.job = '';

      this.step = 0;
    },
  },
};
</script>

<style lang="scss">
.upload-demo {
  margin: 0 auto;
  width: calc(100% - 20px);

  .el-upload {
    width: 100%;
  }

  .el-upload-dragger {
    width: 100%;
    max-width: 360px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/components/UploadFile.vue